export default __webpack_public_path__ + "static/media/부산.fbf4ac29.svg";